import { Tabs } from 'antd';
import s from '../LuckyWheelCampaign.module.less';
import LuckyWheelCampaign from './LuckyWheelCampaign';
import LuckyWheelHistory from './LuckyWheelHistory';
import { useTranslation } from 'next-i18next';
const { TabPane } = Tabs;

interface LuckyWheelCampaignProps {
  id: string;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function LuckyWheelCampaignTab(props: LuckyWheelCampaignProps) {
  const { t: tLayout } = useTranslation('layout');

  const { id, setVisible } = props;
  const tabs = [
    {
      key: 'spin',
      label: tLayout('spin.rotation'),
      component: <LuckyWheelCampaign key={`spin`} id={id} setVisible={setVisible} />,
    },
    {
      key: 'history',
      label: <div className={s.giftCampaignTabName}>{tLayout('spin.spinning_history')}</div>,
      component: <LuckyWheelHistory key={`history`} campaignId={id} />,
    },
  ];
  return (
    <Tabs className={s.tabs}>
      {tabs.map(({ key, label, component }) => (
        <TabPane tab={label} key={key}>
          {component}
        </TabPane>
      ))}
    </Tabs>
  );
}
